import { render, staticRenderFns } from "./generate-serial-number.modal.vue?vue&type=template&id=6bbf03b3&"
import script from "./generate-serial-number.modal.vue?vue&type=script&lang=ts&"
export * from "./generate-serial-number.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports